export default __webpack_public_path__ + "static/media/logo.2727ce85.svg";